import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import i18n from "i18next";

// Sahnede aktif (listeden seçili) işaretçiye eklenen class.
const ACTIVE_MARK_CLASS = "markActive";

export default class MarksList extends Component {
  constructor(props) {
    super(props);
    this.state = { selectedMarkId: null };
  }

  componentDidUpdate(prevProps) {
    const { selectedMarkId } = this.state;
    // Kutu değişti ya da seçili işaretçi silindi → seçimi bırak.
    if (
      selectedMarkId &&
      (prevProps.box_id !== this.props.box_id ||
        !this.props.state ||
        !this.props.state[selectedMarkId])
    ) {
      this.clearSceneHighlight(prevProps.box_id);
      this.setState({ selectedMarkId: null });
      return;
    }
    // İşaretçi yeniden mount olmuş olabilir (sahne re-render) → vurguyu tazele.
    this.syncSceneHighlight();
  }

  componentWillUnmount() {
    this.clearSceneHighlight(this.props.box_id);
  }

  /**
   * Sahnedeki kutunun işaretçilerini (Mark → a#mark-<id>.mapMarker) döndürür.
   */
  getSceneMarks(boxId) {
    const boxEl = document.getElementById("box-" + boxId);
    return boxEl ? Array.from(boxEl.querySelectorAll(".mapMarker")) : [];
  }

  syncSceneHighlight() {
    const activeId = this.state.selectedMarkId ? "mark-" + this.state.selectedMarkId : null;
    this.getSceneMarks(this.props.box_id).forEach((el) => {
      el.classList.toggle(ACTIVE_MARK_CLASS, el.id === activeId);
    });
  }

  clearSceneHighlight(boxId) {
    this.getSceneMarks(boxId).forEach((el) => el.classList.remove(ACTIVE_MARK_CLASS));
  }

  selectMark(id) {
    this.setState({ selectedMarkId: id });
  }

  render() {
    return (
      <div>
        <Button
          className="toolbarButton marksListButton"
          onClick={(e) => {
            this.props.onRichMarksModalToggled();
            e.stopPropagation();
          }}
        >
          {i18n.t("marks.add_mark")}
        </Button>
        <br />
        {this.props.state !== undefined &&
          Object.keys(this.props.state).map((id) => {
            let mark = this.props.state[id];
            if (this.props.box_id !== mark.origin) {
              return null;
            }
            let name = mark.connection;
            let color = mark.color || "#337ab7";
            let widthScroll = Math.max((mark.title.length / 11) * 100, 100);
            try {
              switch (mark.connectMode) {
                case "new":
                  name = this.props.viewToolbars[mark.connection].viewName;
                  break;
                case "existing":
                  name = this.props.viewToolbars[mark.connection].viewName;
                  break;
                case "external":
                  name =
                    mark.connection.length > 25
                      ? mark.connection.substring(0, 25) + "..."
                      : mark.connection;
                  break;
                case "popup":
                  name = "PopUp";
                  break;
              }
            } catch (e) {
              return null;
            }
            const selected = this.state.selectedMarkId === id;
            return (
              <div
                className={"markListBox" + (selected ? " selected" : "")}
                key={id}
                role="button"
                tabIndex={0}
                aria-pressed={selected}
                onClick={() => this.selectMark(id)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    this.selectMark(id);
                  }
                }}
              >
                {mark.connection ? (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={"markToolTip-" + id}>
                        {i18n.t("marks.hover_message") + '"' + name + '"'}
                      </Tooltip>
                    }
                  >
                    <i style={{ color: color }} className="material-icons marklist main">
                      room
                    </i>
                  </OverlayTrigger>
                ) : (
                  <i style={{ color: color }} className="material-icons marklist">
                    room
                  </i>
                )}
                <div
                  className="markNameInToolbarContainer"
                  onMouseOver={() => {
                    let markEl = document.getElementById("mark_" + id);
                    markEl.style.transitionDuration = widthScroll / 100 + "s";
                    markEl.style.width = widthScroll + "%";
                    markEl.style.left = "-" + (widthScroll - 100) + "%";
                  }}
                  onMouseOut={() => {
                    let markEl = document.getElementById("mark_" + id);
                    markEl.style.width = "100%";
                    markEl.style.left = "0%";
                  }}
                >
                  <div id={"mark_" + id} className="markNameInToolbar">
                    {mark.title}
                  </div>
                </div>
                <i
                  className="material-icons marklist"
                  style={{ float: "right" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.props.onRichMarkDeleted(id);
                  }}
                >
                  delete
                </i>
                <i
                  className="material-icons marklist"
                  style={{ float: "right" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.props.onRichMarkEditPressed(mark);
                    this.props.onRichMarksModalToggled();
                  }}
                >
                  edit
                </i>
                <br />
              </div>
            );
          })}
      </div>
    );
  }
}

MarksList.propTypes = {
  /**
   * Id of the box to which the marks belong
   */
  box_id: PropTypes.any,
  /**
   *  State marks object
   */
  state: PropTypes.object.isRequired,
  /**
   * Object including view toolbars (identified by its *id*)
   */
  viewToolbars: PropTypes.object.isRequired,
  /**
   * Muestra/oculta el modal de edición de marcas
   */
  onRichMarksModalToggled: PropTypes.func.isRequired,
  /**
   * Comienza la edición de una marca
   */
  onRichMarkEditPressed: PropTypes.func.isRequired,
  /**
   * Borra una marca
   */
  onRichMarkDeleted: PropTypes.func.isRequired,
};
